import React from 'react';
import PropTypes from 'prop-types';

import {CardActionArea, Stack, Typography} from 'views/components';
import {translate} from 'views/module';

const DomainGuideCard = (props) => {
  const {
    createdByLabel,
    domainGuideData,
  } = props;

  const emptyValue = translate('domainGuide.Detail.EmptyValue');
  const createdAtDate = new Date(domainGuideData.createdAt);
  const createdAtLabel = Number.isNaN(createdAtDate.getTime()) ?
    emptyValue :
    createdAtDate.toLocaleString([], {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  const updatedAtDate = new Date(domainGuideData.updatedAt);
  const updatedAtLabel = Number.isNaN(updatedAtDate.getTime()) ?
    emptyValue :
    updatedAtDate.toLocaleString([], {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  const detailSections = [
    {
      key: 'domainGuideRn',
      label: translate('domainGuide.Detail.Fields.DomainGuideId'),
      value: domainGuideData.domainGuideRn || emptyValue,
    },
    {
      key: 'description',
      label: translate('domainGuide.Detail.Fields.Description'),
      value: domainGuideData.description || emptyValue,
    },
    {
      key: 'status',
      label: translate('domainGuide.Detail.Fields.Status'),
      value: domainGuideData.status ? translate(`domainGuide.Status.${domainGuideData.status}.Title`) : emptyValue,
    },
    {
      key: 'createdBy',
      label: translate('domainGuide.Detail.Fields.CreatedBy'),
      value: createdByLabel || domainGuideData.createdBy || emptyValue,
    },
    {
      key: 'createdAt',
      label: translate('domainGuide.Detail.Fields.CreatedAt'),
      value: createdAtLabel,
    },
    {
      key: 'updatedAt',
      label: translate('domainGuide.Detail.Fields.UpdatedAt'),
      value: updatedAtLabel,
    },
  ];

  return (
    <CardActionArea
      to={`/domain-guide/${domainGuideData.domainGuideRn}`}
      sx={{
        'display': 'block',
        'textAlign': 'left',
        'backgroundColor': '#FFFFFF',
        'border': '1px solid #E8E4DE',
        'borderRadius': '8px',
        'p': 1.5,
        '&:hover': {
          backgroundColor: '#F8F6F3',
        },
      }}
    >
      <Stack sx={{gap: 1}}>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 500,
            color: '#1A1916',
            wordBreak: 'break-word',
          }}
        >
          {domainGuideData.name || emptyValue}
        </Typography>
        <Stack sx={{gap: 0.75}}>
          {
            detailSections.map((section) => (
              <Stack key={section.key} sx={{gap: '2px'}}>
                <Typography
                  sx={{
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#A8A49E',
                    textTransform: 'uppercase',
                  }}
                >
                  {section.label}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 400,
                    color: '#6B6760',
                    lineHeight: '16px',
                    wordBreak: 'break-word',
                  }}
                >
                  {section.value}
                </Typography>
              </Stack>
            ))
          }
        </Stack>
      </Stack>
    </CardActionArea>
  );
};

DomainGuideCard.propTypes = {
  createdByLabel: PropTypes.string,
  domainGuideData: PropTypes.object.isRequired,
};

export default React.memo(DomainGuideCard);
